export default {"src":"/_next/static/media/Logo2.ec118cd1.svg","height":46,"width":101,"blurWidth":0,"blurHeight":0};